export const ADD_PUBLIC_PAGE_DATA = 'ADD_PUBLIC_PAGE_DATA'
export const CLEAR_PUBLIC_PAGE_DATA = 'CLEAR_PUBLIC_PAGE_DATA'

const initialSate = {}

export const storePublicPageData = (data) => ({
  type: ADD_PUBLIC_PAGE_DATA,
  data,
})

export const clearPublicPageDataFromRedux = () => ({
  type: CLEAR_PUBLIC_PAGE_DATA,
})

export default (state = initialSate, action) => {
  switch (action.type) {
    case ADD_PUBLIC_PAGE_DATA:
      const { data } = action
      return { ...state, ...data }
    case CLEAR_PUBLIC_PAGE_DATA:
      return {}
    default:
  }
  return state
}
